/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ErrorDetailsDto {
  errorCode: ErrorDetailsDtoErrorCodeEnum;
  details?: string;
}

export interface ErrorResponse {
  error: ErrorDetailsDto;
}

export interface EditVehicleRequest {
  /** @format uuid */
  id: string;
  registrationNumber?: string;
  registrationCountry?: string;
  vehicleCategory?: VehicleCategory;
  /** @pattern ^$|(^[a-zA-Z0-9\p{IsLatin} ,-]{1,19}$) */
  name?: string;
  /** @uniqueItems true */
  costCenters: string[];
  assignedEmployees?: string[];
}

export enum VehicleCategory {
  CATEGORY1 = 'CATEGORY_1',
  CATEGORY2 = 'CATEGORY_2',
  CATEGORY3 = 'CATEGORY_3',
  CATEGORY4 = 'CATEGORY_4',
  CATEGORY5 = 'CATEGORY_5',
  CATEGORY6 = 'CATEGORY_6',
}

export interface BulkEditVehicleRequest {
  ids: string[];
  costCenters?: string[];
}

export interface BulkDeleteVehicleRequest {
  ids: string[];
}

export interface EditUserDto {
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  phoneExt?: string;
  role: Role;
  marketingEmailManagementAccepted?: boolean;
  marketingPhoneManagementAccepted?: boolean;
  costCenters?: string[];
}

export enum Role {
  OPERATOR_ROLE = 'OPERATOR_ROLE',
  ADMINISTRATOR_ROLE = 'ADMINISTRATOR_ROLE',
  OWNER_ROLE = 'OWNER_ROLE',
  CUSTOMER_SUPPORT_ROLE = 'CUSTOMER_SUPPORT_ROLE',
  NO_ROLE = 'NO_ROLE',
}

export enum ConsentType {
  WALLET_TERMS = 'WALLET_TERMS',
  TERMS = 'TERMS',
  DATA_PROCESSING = 'DATA_PROCESSING',
}

export interface CostCenterDto {
  /** @format uuid */
  id: string;
  name: string;
  defaultCostCenter?: boolean;
  automaticAssignment?: boolean;
}

export enum Language {
  PL = 'PL',
  EN = 'EN',
  UK = 'UK',
  UA = 'UA',
  RU = 'RU',
}

export interface OnboardingInfoDto {
  status: OnboardingStatus;
  step: OnboardingStep;
  mode: OnboardingMode;
  hasSubscriptionsAssigned: boolean;
}

export enum OnboardingMode {
  SINGLE = 'SINGLE',
  BULK = 'BULK',
}

export enum OnboardingStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  SKIPPED = 'SKIPPED',
}

export enum OnboardingStep {
  ADD_VEHICLES = 'ADD_VEHICLES',
  ADD_EMPLOYEES = 'ADD_EMPLOYEES',
  IMPORT_SUMMARY = 'IMPORT_SUMMARY',
  IMPORT_VEHICLES = 'IMPORT_VEHICLES',
  IMPORT_EMPLOYEES = 'IMPORT_EMPLOYEES',
  TOP_UP_BALANCE = 'TOP_UP_BALANCE',
  TOP_UP_BALANCE_SUCCESS = 'TOP_UP_BALANCE_SUCCESS',
  TOP_UP_BALANCE_FAILED = 'TOP_UP_BALANCE_FAILED',
  SUBSCRIPTIONS = 'SUBSCRIPTIONS',
  COMPANY_POLICY = 'COMPANY_POLICY',
  FINISH = 'FINISH',
}

export interface UserCompanyDto {
  /** @format uuid */
  id: string;
  role: Role;
  nip: string;
  name: string;
  currency: string;
  companyType: string;
}

export interface UserConsentDto {
  consentCode?: string;
  isAccepted?: boolean;
  type?: ConsentType;
}

export interface UserDto {
  /** @format uuid */
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  phoneExt: string;
  confirmed?: boolean;
  preferredLanguage?: Language;
  companies: UserCompanyDto[];
  onboarding?: OnboardingInfoDto;
  consents?: UserConsentDto[];
  acceptedMarketingConsents?: string[];
  marketingPhoneManagementAccepted?: boolean;
  marketingEmailManagementAccepted?: boolean;
  costCenters?: CostCenterDto[];
}

export interface OnboardingNextStepRequest {
  nextStep: OnboardingStep;
}

export interface OnboardingEditVehicleRequest {
  /** @format uuid */
  id: string;
  /**
   * @minLength 4
   * @maxLength 10
   * @pattern ^[a-zA-Z0-9]+$
   */
  registrationNumber: string;
  registrationCountry: string;
  vehicleCategory: VehicleCategory;
  /** @pattern ^$|(^[a-zA-Z0-9\p{IsLatin} ,-]{1,19}$) */
  name?: string;
  labels?: string[];
}

export interface OnboardingEditEmployeeRequest {
  /** @format uuid */
  id: string;
  /**
   * @minLength 3
   * @maxLength 50
   * @pattern ^[a-zA-Z0-9\p{IsLatin} -]*
   */
  firstName: string;
  /**
   * @minLength 3
   * @maxLength 50
   * @pattern ^[a-zA-Z0-9\p{IsLatin} -]*
   */
  lastName: string;
  /** @pattern \d{7,15} */
  phoneNumber: string;
  /**
   * @minLength 2
   * @maxLength 5
   */
  phoneExt: string;
  email?: string;
  /** @uniqueItems true */
  labels?: string[];
  /** @uniqueItems true */
  assignedVehicles?: string[];
}

export interface NotificationIdsDto {
  notificationIds: string[];
}

export interface EditEmployeeRequest {
  /** @format uuid */
  id: string;
  /**
   * @minLength 3
   * @maxLength 50
   * @pattern ^[a-zA-Z0-9\p{IsLatin} -]*$
   */
  firstName: string | null;
  /**
   * @minLength 3
   * @maxLength 50
   * @pattern ^[a-zA-Z0-9\p{IsLatin} -]*$
   */
  lastName: string | null;
  /** @pattern \d{7,15} */
  phoneNumber: string;
  /**
   * @minLength 2
   * @maxLength 5
   */
  phoneExt: string;
  email?: string;
  labels?: string[];
  profiles?: string[];
  assignedVehicles?: string[];
  /** @format uuid */
  costCenter?: string;
}

export interface PutEmployeeProfilesRequest {
  employeeProfiles?: string[];
}

export interface BulkEditEmployeesProfilesRequest {
  employeeIds?: string[];
  profiles?: string[];
}

export interface BulkEditEmployeesLabelsRequest {
  employeeIds?: string[];
  labels?: string[];
}

export interface BulkDeleteEmployeesRequest {
  employeeIds?: string[];
}

export interface EditCostCenterRequestDto {
  /** @pattern \S[\S\s]{0,148}\S|\S */
  name: string;
  companyName: string;
  street: string;
  buildingNumber: string;
  apartmentNumber?: string;
  zipCode: string;
  city: string;
  defaultCostCenter?: boolean;
  newDefaultCostCenterId?: string;
  automaticAssignment?: boolean;
  newAutomaticAssignmentCostCenterId?: string;
  assignedUsers?: string[];
  recipients?: string[];
}

export interface CompanyServicesResponse {
  parkingConfiguration?: OnboardingSaveParkingDto;
  highwaysConfiguration?: OnboardingSaveHighwaysDto;
  publicTransportConfiguration?: OnboardingSavePublicTransportDto;
}

export enum DayOfWeek {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export interface EditCompanyPolicyRequest {
  name: string;
  color?: string;
  /** @format date-time */
  validFrom?: string;
  /** @format date-time */
  validTo?: string;
  maxAmount?: number;
  assignedEmployees: string[];
  services: CompanyServicesResponse;
}

export interface OnboardingSaveHighwaysDto {
  highwaySections: string[];
  days: DayOfWeek[];
}

export interface OnboardingSaveParkingDto {
  cities: string[];
  zones: string[];
  unlimitedTime: boolean;
  /** @pattern \d{2} */
  timeFrom?: string;
  /** @pattern \d{2} */
  timeTo?: string;
  days: DayOfWeek[];
}

export interface OnboardingSavePublicTransportDto {
  cities: string[];
  zones: string[];
  unlimitedTime: boolean;
  /** @pattern \d{2} */
  timeFrom?: string;
  /** @pattern \d{2} */
  timeTo?: string;
  days: DayOfWeek[];
}

export interface UpdateAddressDto {
  /**
   * @minLength 1
   * @maxLength 50
   */
  street: string;
  /**
   * @minLength 1
   * @maxLength 10
   */
  buildingNumber: string;
  apartmentNumber?: string;
  /** @pattern \d{2}-\d{3} */
  zipCode: string;
  /**
   * @minLength 1
   * @maxLength 50
   */
  city: string;
}

export interface UpdateCompanyDetailsRequest {
  /**
   * @minLength 1
   * @maxLength 150
   */
  companyName: string;
  primaryAddress: UpdateAddressDto;
  correspondenceAddress?: UpdateAddressDto;
}

export interface AddVehicleRequest {
  /**
   * @minLength 4
   * @maxLength 10
   * @pattern ^[a-zA-Z0-9]+$
   */
  registrationNumber: string;
  /** @pattern ^$|(^[a-zA-Z0-9\p{IsLatin} ,-]{1,19}$) */
  name?: string;
  registrationCountry: string;
  vehicleCategory: VehicleCategory;
  costCenters: string[];
  assignedEmployees?: string[];
}

export interface VehicleImportRequest {
  /** @format binary */
  file: File;
}

export interface ImportSummaryResponse {
  /** @format int32 */
  numOfEntities?: number;
  /** @format int32 */
  numOfErrors?: number;
}

export interface PaginationRequest {
  /**
   * @format int32
   * @min 0
   */
  pageIndex?: number;
  /**
   * @format int32
   * @min 1
   */
  pageSize?: number;
}

export interface RequestFieldFilter {
  field: RequestFieldFilterType;
  value: string;
}

export enum RequestFieldFilterType {
  VEHICLE_REGISTRATION_COUNTRY = 'VEHICLE_REGISTRATION_COUNTRY',
  VEHICLE_CATEGORY = 'VEHICLE_CATEGORY',
  VEHICLE_SERVICE = 'VEHICLE_SERVICE',
  EMPLOYEE_PROFILE = 'EMPLOYEE_PROFILE',
  EMPLOYEE_SERVICE = 'EMPLOYEE_SERVICE',
  DATE_FROM = 'DATE_FROM',
  DATE_TO = 'DATE_TO',
  TRANSACTION_DEPARTMENT = 'TRANSACTION_DEPARTMENT',
  TRANSACTION_COST_CENTER = 'TRANSACTION_COST_CENTER',
  TRANSACTION_AMOUNT_FROM = 'TRANSACTION_AMOUNT_FROM',
  TRANSACTION_AMOUNT_TO = 'TRANSACTION_AMOUNT_TO',
  NOTIFICATION_TYPE = 'NOTIFICATION_TYPE',
  NOTIFICATION_READ_STATUS = 'NOTIFICATION_READ_STATUS',
}

export interface RequestFilter {
  /**
   * @minLength 2
   * @maxLength 2147483647
   */
  search?: string;
  fields?: RequestFieldFilter[];
}

export interface RequestSort {
  direction: string;
  columnName: string;
}

export interface SearchRequest {
  sort?: RequestSort;
  pagination?: PaginationRequest;
  filters?: RequestFilter;
  ids?: string[];
}

export interface Pagination {
  /** @format int32 */
  totalItems: number;
  /** @format int32 */
  pageIndex: number;
  /** @format int32 */
  pageSize: number;
}

export interface PaginationResultsVehicleAssignTableDataDto {
  pagination: Pagination;
  data: VehicleAssignTableDataDto[];
}

export interface VehicleAssignTableDataDto {
  /** @format uuid */
  id: string;
  registrationNumber: string;
  name: string;
}

export interface ImpersonatorUserDto {
  /** @format uuid */
  id: string;
  username: string;
}

export interface MeUserDto {
  /** @format uuid */
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  phoneExt: string;
  impersonator?: ImpersonatorUserDto;
  preferredLanguage?: Language;
  companies: UserCompanyDto[];
  onboardingStatus?: OnboardingStatus;
  acceptedMarketingConsents?: string[];
  marketingPhoneManagementAccepted?: boolean;
  marketingEmailManagementAccepted?: boolean;
  hasAllRequiredConsentsAccepted?: boolean;
}

export interface AcceptConsentsRequest {
  walletTermsAccepted: RegistrationTermsAcceptanceDto;
  termsAccepted: RegistrationTermsAcceptanceDto;
  dataProcessingAccepted: RegistrationTermsAcceptanceDto;
  marketingPhoneManagementAccepted?: boolean;
  marketingEmailManagementAccepted?: boolean;
}

export interface RegistrationTermsAcceptanceDto {
  documentCode?: string;
  accepted?: boolean;
}

export interface InviteUserRequest {
  firstName: string;
  lastName: string;
  email: string;
  role: Role;
  costCenters?: string[];
}

export interface UpgradeSubscriptionDto {
  subscriptionCode: string;
}

export interface DowngradeSubscriptionDto {
  questionCodes: string[];
  subscriptionCode: string;
}

export interface SetBackupSubscriptionDto {
  subscriptionCode: string;
}

export interface OnboardingAddVehicleDto {
  /** @format uuid */
  id?: string;
  /**
   * @minLength 4
   * @maxLength 10
   * @pattern ^[a-zA-Z0-9]+$
   */
  registrationNumber: string;
  registrationCountry: string;
  vehicleCategory: VehicleCategory;
  /** @pattern ^$|(^[a-zA-Z0-9\p{IsLatin} ,-]{1,19}$) */
  name?: string;
  labels?: string[];
}

export interface OnboardingAddVehiclesRequest {
  vehicles: OnboardingAddVehicleDto[];
  nextStep: OnboardingStep;
}

export interface OnboardingAddVehiclesResponse {
  error?: ResponseErrorDto;
}

export interface ResponseErrorDto {
  errorCode: string;
  details?: object;
}

export interface CardDto {
  token: string;
  mask: string;
}

export interface FinancialAccountNewCardTopUpRequest {
  /** @min 20 */
  amount?: number;
  /**
   * @minLength 3
   * @maxLength 50
   * @pattern ^[a-zA-Z0-9\p{IsLatin} -]*$
   */
  firstName: string;
  /**
   * @minLength 3
   * @maxLength 50
   * @pattern ^[a-zA-Z0-9\p{IsLatin} -]*$
   */
  lastName: string;
  country?: string;
  zipCode?: string;
  card: CardDto;
  /** @format uuid */
  costCenterId?: string;
}

export interface PaymentResponse {
  /** @format uri */
  redirectUri: string;
}

export interface OnboardingSelectSubscriptionRequest {
  subscriptionCode: string;
  nextStep: OnboardingStep;
}

export interface OnboardingSummarizeImportRequest {
  nextStep: OnboardingStep;
}

export interface OnboardingImportRequest {
  /** @format binary */
  file: File;
  nextStep: OnboardingStep;
}

export interface OnboardingAddEmployeeDto {
  /**
   * @minLength 3
   * @maxLength 50
   * @pattern ^[a-zA-Z0-9\p{IsLatin} -]*$
   */
  firstName: string;
  /**
   * @minLength 3
   * @maxLength 50
   * @pattern ^[a-zA-Z0-9\p{IsLatin} -]*$
   */
  lastName: string;
  /**
   * @minLength 2
   * @maxLength 5
   */
  phoneExt: string;
  /** @pattern \d{7,15} */
  phoneNumber: string;
  email?: string;
  labels?: string[];
  vehicles?: string[];
}

export interface OnboardingAddEmployeesRequest {
  employees: OnboardingAddEmployeeDto[];
  nextStep: OnboardingStep;
}

export interface OnboardingAddEmployeesResponse {
  error?: ResponseErrorDto;
}

export interface OnboardingSaveCompanyPolicyRequest {
  parkingConfiguration?: OnboardingSaveParkingDto;
  highwaysConfiguration?: OnboardingSaveHighwaysDto;
  publicTransportConfiguration?: OnboardingSavePublicTransportDto;
  nextStep: OnboardingStep;
}

export enum LabelType {
  VEHICLE = 'VEHICLE',
  EMPLOYEE = 'EMPLOYEE',
}

export interface AddLabelRequest {
  /**
   * @minLength 2
   * @maxLength 100
   * @pattern ^[a-zA-Z0-9\p{IsLatin} ,-.]*$
   */
  name: string;
}

export interface LabelDto {
  /** @format uuid */
  id: string;
  name: string;
  type: LabelType;
}

export interface SendApplicationRequest {
  /** @format int64 */
  titleId: number;
  title: string;
  content: string;
}

export interface FinancialAccountExistingCardTopUpRequest {
  /** @min 20 */
  amount: number;
  paymentMethodId: string;
}

export interface FinancialAccountTopUpRequest {
  newCard?: FinancialAccountNewCardTopUpRequest;
  existingCard?: FinancialAccountExistingCardTopUpRequest;
  /** @format uuid */
  costCenterId: string;
}

export interface FinancialAccountDetailsRequest {
  paymentCards?: string[];
  /** @format uuid */
  defaultPaymentCard?: string;
}

export interface CreateLinkRequest {
  objectName: string;
  bucketName: string;
}

export interface AddEmployeeRequest {
  /**
   * @minLength 3
   * @maxLength 50
   * @pattern ^[a-zA-Z0-9\p{IsLatin} -]*$
   */
  firstName: string;
  /**
   * @minLength 3
   * @maxLength 50
   * @pattern ^[a-zA-Z0-9\p{IsLatin} -]*$
   */
  lastName: string;
  /** @pattern \d{7,15} */
  phoneNumber: string;
  /**
   * @minLength 2
   * @maxLength 5
   */
  phoneExt: string;
  email?: string;
  assignedVehicles?: string[];
  labels?: string[];
  profiles?: string[];
  /** @format uuid */
  costCenter?: string;
}

export interface EmployeeImportRequest {
  /** @format binary */
  file: File;
}

export interface EmployeeAssignTableDataDto {
  /** @format uuid */
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  phoneExt: string;
  labels?: LabelDto[];
}

export interface PaginationResultsEmployeeAssignTableDataDto {
  pagination: Pagination;
  data: EmployeeAssignTableDataDto[];
}

export interface CreateCostCenterRequestDto {
  /** @pattern \S[\S\s]{0,148}\S|\S */
  name: string;
  nip: string;
  companyName: string;
  street: string;
  buildingNumber: string;
  apartmentNumber?: string;
  zipCode: string;
  city: string;
  defaultCostCenter?: boolean;
  automaticAssignment?: boolean;
  useExistingTechnicalAccountNumber?: boolean;
  technicalAccountId?: string;
  assignedUsers: string[];
  recipients: string[];
}

export interface CostCenterUserAssignTableDataDto {
  /** @format uuid */
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  cannotBeDetached?: boolean;
}

export interface PaginationResultsCostCenterUserAssignTableDataDto {
  pagination: Pagination;
  data: CostCenterUserAssignTableDataDto[];
}

export interface RegisterCompanyDataDto {
  name?: string;
  nip?: string;
  street?: string;
  buildingNumber?: string;
  apartmentNumber?: string;
  zipCode?: string;
  city?: string;
}

export interface RegisterCompanyRequestDto {
  /**
   * @minLength 3
   * @maxLength 50
   * @pattern ^[a-zA-Z0-9\p{IsLatin} -]*$
   */
  firstName: string;
  /**
   * @minLength 3
   * @maxLength 50
   * @pattern ^[a-zA-Z0-9\p{IsLatin} -]*$
   */
  lastName: string;
  email: string;
  phoneNumber?: string;
  phoneExt?: string;
  nip?: string;
  walletTermsAccepted: RegistrationTermsAcceptanceDto;
  termsAccepted: RegistrationTermsAcceptanceDto;
  dataProcessingAccepted: RegistrationTermsAcceptanceDto;
  marketingPhoneManagementAccepted?: boolean;
  marketingEmailManagementAccepted?: boolean;
  originalCompanyData?: RegisterCompanyDataDto;
  finalCompanyData?: RegisterCompanyDataDto;
  initialSubscriptionCode?: string;
}

export interface RegisterCompanyResponseDto {
  resendEmailUrl?: string;
}

export interface EmployeeDto {
  /** @format uuid */
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  phoneExt?: string;
  email: string;
  resource?: ResourceDto;
}

export interface PaginationResultsVehicleTableDataDto {
  pagination: Pagination;
  data: VehicleTableDataDto[];
}

export interface ResourceDto {
  /** @format uuid */
  id: string;
  /** @format uuid */
  companyId: string;
  type: ResourceType;
}

export enum ResourceType {
  EMPLOYEE = 'EMPLOYEE',
  VEHICLE = 'VEHICLE',
}

export enum ServiceType {
  PUBLIC_TRANSPORT = 'PUBLIC_TRANSPORT',
  HIGHWAYS = 'HIGHWAYS',
  PARKINGS = 'PARKINGS',
}

export interface VehicleTableDataDto {
  /** @format uuid */
  id: string;
  registrationNumber: string;
  registrationCountry: string;
  vehicleCategory: VehicleCategory;
  name?: string;
  labels?: LabelDto[];
  employees?: EmployeeDto[];
  services?: ServiceType[];
  costCenters?: CostCenterDto[];
}

export interface GetVehicleResponse {
  /** @format uuid */
  id: string;
  registrationNumber: string;
  registrationCountry: string;
  vehicleCategory: VehicleCategory;
  name: string;
  costCenters?: string[];
  assignedEmployees?: string[];
}

export interface VehicleRegistrationNumberDto {
  /** @format uuid */
  id: string;
  registrationNumber: string;
}

export interface PaginationResultsUserTableDto {
  pagination: Pagination;
  data: UserTableDto[];
}

export interface UserTableDto {
  /** @format uuid */
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  phoneExt: string;
  role: Role;
  costCenters: CostCenterDto[];
}

export interface UserConsentsDto {
  walletTermsAccepted?: boolean;
  termsAccepted?: boolean;
  dataProcessingAccepted?: boolean;
  marketingPhoneManagementAccepted?: boolean;
  marketingEmailManagementAccepted?: boolean;
}

export interface TopBarMessageResponse {
  type?: TopBarMessageResponseTypeEnum;
  accountsNumbers?: string[];
}

export interface AvailableSubscriptionsResponse {
  defaultCostCenter: CostCenterDto;
  selectedSubscriptionCode?: string;
  /** @format int64 */
  numOfEmployees: number;
  /** @format int64 */
  numOfVehicles: number;
}

export interface DowngradeFormulaQuestionDto {
  id: string;
  question: string;
}

export interface DowngradeFormulaQuestionsResponse {
  items: DowngradeFormulaQuestionDto[];
}

export interface OpensearchSearchRequest {
  openSearchDataType: OpensearchSearchRequestOpenSearchDataTypeEnum;
  sort?: RequestSort;
  filters?: RequestFilter;
  /**
   * @format int32
   * @min 1
   */
  pageSize?: number;
  /** @format date */
  dateFrom?: string;
  /** @format date */
  dateTo?: string;
  /** @format uuid */
  costCenterId?: string;
  scrollId?: string;
}

export interface OpensearchSearchResponseListObject {
  data: object[][];
  scrollId: string;
  /** @format int32 */
  totalHits: number;
}

export interface ColumnConfiguration {
  column: ColumnConfigurationColumnEnum;
  columnType: ColumnConfigurationColumnTypeEnum;
  isVisible: boolean;
  isSortable: boolean;
  filters?: OpenSearchTableFilter[];
}

export interface OpenSearchTableFilter {
  id: RequestFieldFilterType;
  filterType: OpenSearchTableFilterType;
  availableOptions: OpenSearchTableFilterAvailableOption[];
}

export interface OpenSearchTableFilterAvailableOption {
  id: string;
  value: string;
}

export enum OpenSearchTableFilterType {
  TEXT_INPUT = 'TEXT_INPUT',
  NUMBER_INPUT = 'NUMBER_INPUT',
  MULTI_SELECT = 'MULTI_SELECT',
  SELECT = 'SELECT',
}

export interface FinancialAccountTopUpConfigurationResponse {
  /** @format int32 */
  suggestedTopUpAmount: number;
  costCenterAccountNumber?: string;
  payUID: string;
}

export interface ImportSummaryDto {
  /** @format int32 */
  numOfEntities?: number;
  /** @format int32 */
  numOfErrors?: number;
}

export interface OnboardingImportSummaryDataResponse {
  vehicles: ImportSummaryDto;
  employees: ImportSummaryDto;
}

export interface EmployeeVehicleDto {
  /** @format uuid */
  id: string;
  registrationNumber: string;
}

export interface OnboardingEmployeeTableDataDto {
  /** @format uuid */
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  phoneExt: string;
  email?: string;
  labels?: LabelDto[];
  assignedVehicles?: EmployeeVehicleDto[];
}

export interface PaginationResultsOnboardingEmployeeTableDataDto {
  pagination: Pagination;
  data: OnboardingEmployeeTableDataDto[];
}

export interface OnboardingDataForEmployeesResponse {
  vehicles: OnboardingVehicleDto[];
}

export interface OnboardingVehicleDto {
  /** @format uuid */
  id: string;
  registrationNumber: string;
  registrationCountry: string;
  vehicleCategory: VehicleCategory;
  name?: string;
  labels?: string[];
}

export interface OnboardingCompanyPolicyResponse {
  availableServices: ServiceDto[];
}

export interface ServiceDto {
  id?: string;
  type: ServiceType;
}

export interface NotificationDto {
  id: string;
  readStatus: NotificationDtoReadStatusEnum;
  type: NotificationType;
  title: string;
  content: string;
  /** @format date-time */
  createdAt: string;
}

export enum NotificationType {
  ALERT = 'ALERT',
  DANGER = 'DANGER',
  SUCCESS = 'SUCCESS',
  INFO = 'INFO',
  WARNING = 'WARNING',
}

export interface PaginationResultsNotificationDto {
  pagination: Pagination;
  data: NotificationDto[];
}

export interface NotificationCountDto {
  /** @format int64 */
  unreadCount?: number;
}

export interface CostCenterFinancialAccountDto {
  /** @format uuid */
  id?: string;
  name?: string;
}

export interface FinancialAccountDto {
  /** @format uuid */
  id: string;
  iban: string;
  costCenters?: CostCenterFinancialAccountDto[];
}

export interface FinancialAccountDetailsResponse {
  iban?: string;
}

export interface AvailablePaymentCardDto {
  /** @format uuid */
  paymentMethodId: string;
  cardNumber: string;
  cardExpirationMonth: string;
  cardExpirationYear: string;
  cardBrand: string;
  imageUrl: string;
}

export interface GenerateReportResponse {
  status?: GenerateReportResponseStatusEnum;
  /** @format date-time */
  createdAt?: string;
  link?: string;
}

export interface CompanyPolicyMiniResponse {
  /** @format uuid */
  id: string;
  name: string;
  color?: string;
  isDefault?: boolean;
  isActive?: boolean;
}

export interface EmployeeTableDataDto {
  /** @format uuid */
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  phoneExt: string;
  email?: string;
  labels?: LabelDto[];
  assignedVehicles?: EmployeeVehicleDto[];
  services?: ServiceDto[];
  costCenters?: CostCenterDto[];
  profiles?: CompanyPolicyMiniResponse[];
}

export interface PaginationResultsEmployeeTableDataDto {
  pagination: Pagination;
  data: EmployeeTableDataDto[];
}

export interface GetEmployeeResponse {
  /** @format uuid */
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  phoneExt?: string;
  email: string;
  costCenters: string[];
  assignedVehicles?: string[];
  profiles?: string[];
}

export interface UUIDNameResponse {
  /** @format uuid */
  id?: string;
  name?: string;
}

export interface DashboardAccountResponse {
  costCenters: DashboardCostCenterResponse[];
  iban: string;
  balance: number;
  /** @format int32 */
  daysLeft?: number;
}

export interface DashboardCostCenterResponse {
  /** @format uuid */
  id: string;
  name: string;
}

export interface DashboardResponse {
  /** @format int32 */
  numberOfVehicles: number;
  /** @format int32 */
  numberOfEmployees: number;
  currentMonthSpendings: number;
  accounts?: DashboardAccountResponse[];
  services?: DashboardServiceResponse[];
  topUps?: DashboardTopUpResponse[];
}

export interface DashboardServiceResponse {
  name: string;
  balance: number;
}

export interface DashboardTopUpResponse {
  /** @format date-time */
  date: string;
  iban: string;
  amount: number;
}

export interface CostCenterDisplayDto {
  /** @format uuid */
  id: string;
  name: string;
  nip: string;
  companyName: string;
  street: string;
  buildingNumber: string;
  apartmentNumber?: string;
  zipCode: string;
  city: string;
  defaultCostCenter?: boolean;
  automaticAssignment?: boolean;
  currency?: string;
  /** @format uuid */
  technicalAccountId: string;
  accountIban: string;
  assignedUsers?: string[];
  recipients?: string[];
}

export interface InvoiceResponse {
  id: string;
  date: string;
  name: string;
  type: string;
  bucketName: string;
  objectName: string;
}

export interface CostCenterExpensesResponse {
  /** @format int32 */
  previousMonthComparisonPercentage: number;
  currency: string;
  amount: number;
}

export interface CostCenterFinancialAccountSummaryResponse {
  /** @format uuid */
  financialAccountId: string;
  currency: string;
  amount: number;
}

export interface CostCenterTableDto {
  /** @format uuid */
  id: string;
  name: string;
  defaultCostCenter?: boolean;
  currency?: string;
  accountNumber?: string;
  currentMonthExpenses?: number;
  currentBalance?: number;
}

export interface PaginationResultsCostCenterTableDto {
  pagination: Pagination;
  data: CostCenterTableDto[];
}

export interface CompanyPolicyResponse {
  /** @format uuid */
  id: string;
  name: string;
  color?: string;
  /** @format date */
  validFrom?: string;
  /** @format date */
  validTo?: string;
  maxAmount?: number;
  assignedEmployees: string[];
  services: CompanyServicesResponse;
  isDefault?: boolean;
  isActive?: boolean;
}

export interface CompanyPolicySubscribtionDataResponse {
  availableServices: ServiceDto[];
}

export interface DefaultCompanyPolicyResponse {
  /** @format uuid */
  defaultCompanyPolicy?: string;
}

export interface AddressDto {
  street: string;
  buildingNumber: string;
  apartmentNumber?: string;
  zipCode: string;
  city: string;
}

export interface CompanyDetailsDto {
  /** @format uuid */
  id: string;
  companyName: string;
  nip: string;
  primaryAddress: AddressDto;
  correspondenceAddress?: AddressDto;
}

export interface InvoiceDataResponse {
  nip?: string;
  companyName?: string;
  street?: string;
  buildingNumber?: string;
  apartmentNumber?: string;
  zipCode?: string;
  city?: string;
  /** @format uuid */
  financialAccountId?: string;
  recipientsList?: string[];
}

export interface CostCenterResponse {
  /** @format uuid */
  id?: string;
  default?: boolean;
}

export interface AccountCostCenterResponse {
  /** @format uuid */
  accountId?: string;
  /** @format uuid */
  costCenterId?: string;
  /** @format uuid */
  financialAccountId?: string;
}

export interface EmployeePrivateDataResponsePrivateCompanyResources {
  entity: PrivateEntity;
  payload: PrivatePayloadPrivateCompanyResources;
  metadata: PrivateMetadata;
  version: string;
}

export interface PrivateCompanyResources {
  /** @format uuid */
  companyId: string;
  companyName: string;
  vehicles: PrivateVehicle[];
  employee: PrivateEmployee;
}

export interface PrivateEmployee {
  name: string;
  surname: string;
  /** @format uuid */
  id: string;
}

export interface PrivateEntity {
  type?: string;
  phoneNumber?: string;
}

export interface PrivateMetadata {
  source: string;
  /** @format date-time */
  timestamp: string;
}

export interface PrivatePayloadPrivateCompanyResources {
  companies?: PrivateCompanyResources[];
}

export interface PrivateVehicle {
  /** @format uuid */
  vehicleId: string;
  vehicleName: string;
  licensePlate: string;
}

export interface EmployeePrivateDataResponsePrivateCompanyAssignments {
  entity: PrivateEntity;
  payload: PrivatePayloadPrivateCompanyAssignments;
  metadata: PrivateMetadata;
  version: string;
}

export interface PrivateCompanyAssignments {
  /** @format uuid */
  companyId: string;
  companyName: string;
  employee: PrivateEmployee;
  labels: string[];
  costCenters: PrivateCostCenter[];
  employeeProfiles: PrivateEmployeeProfile[];
}

export interface PrivateCostCenter {
  /** @format uuid */
  costCenterId: string;
  paymentAccountId: string;
}

export interface PrivateEmployeeProfile {
  /** @format uuid */
  companyPolicyId: string;
  name: string;
}

export interface PrivatePayloadPrivateCompanyAssignments {
  companies?: PrivateCompanyAssignments[];
}

export interface PaginationResultsUserTablePrivateDto {
  pagination: Pagination;
  data: UserTablePrivateDto[];
}

export interface UserAccountTablePrivateDto {
  name: string;
  nip: string;
  role: Role;
}

export interface UserTablePrivateDto {
  /** @format uuid */
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  accounts: UserAccountTablePrivateDto[];
}

export enum ErrorDetailsDtoErrorCodeEnum {
  REGISTRATION_NUMBER_ONLY_NUMBERS_LETTERS = 'REGISTRATION_NUMBER_ONLY_NUMBERS_LETTERS',
  REGISTRATION_EMAIL_ALREADY_IN_USE = 'REGISTRATION_EMAIL_ALREADY_IN_USE',
  REGISTRATION_NIP_NOT_FOUND = 'REGISTRATION_NIP_NOT_FOUND',
  REGISTRATION_NUMBER_ALREADY_EXISTS = 'REGISTRATION_NUMBER_ALREADY_EXISTS',
  ONBOARDING_PHONE_NUMBER_NOT_UNIQUE = 'ONBOARDING_PHONE_NUMBER_NOT_UNIQUE',
  ONBOARDING_REGISTRATION_NUMBER_NOT_UNIQUE = 'ONBOARDING_REGISTRATION_NUMBER_NOT_UNIQUE',
  COST_CENTER_NAME_ALREADY_EXISTS = 'COST_CENTER_NAME_ALREADY_EXISTS',
  COST_CENTER_VALIDATION_ERROR = 'COST_CENTER_VALIDATION_ERROR',
  COST_CENTER_NO_PERMISSION_ERROR = 'COST_CENTER_NO_PERMISSION_ERROR',
  COST_CENTER_NOT_FOUND = 'COST_CENTER_NOT_FOUND',
  COST_CENTER_UNAUTHORIZED_EDIT = 'COST_CENTER_UNAUTHORIZED_EDIT',
  COST_CENTER_DISABLE_FLAGS_FOR_SINGLE_COST_CENTER = 'COST_CENTER_DISABLE_FLAGS_FOR_SINGLE_COST_CENTER',
  COST_CENTER_CANNOT_REMOVE_LAST_COST_CENTER_OF_USER = 'COST_CENTER_CANNOT_REMOVE_LAST_COST_CENTER_OF_USER',
  IMPORT_FILE_CORRUPTED = 'IMPORT_FILE_CORRUPTED',
  IMPORT_INVALID_DELIMITER = 'IMPORT_INVALID_DELIMITER',
  IMPORT_FILE_EMPTY = 'IMPORT_FILE_EMPTY',
  USER_EDIT_ERROR = 'USER_EDIT_ERROR',
  USER_EDIT_PHONE_NUMBER_NOT_UNIQUE = 'USER_EDIT_PHONE_NUMBER_NOT_UNIQUE',
  USER_INVITE_EMAIL_NOT_UNIQUE = 'USER_INVITE_EMAIL_NOT_UNIQUE',
  USER_INVITE_ERROR = 'USER_INVITE_ERROR',
  USER_NOT_EXIST_IN_COMPANY = 'USER_NOT_EXIST_IN_COMPANY',
  FIRST_NAME_MUST_CONTAIN_ONLY_ALPHANUMERIC = 'FIRST_NAME_MUST_CONTAIN_ONLY_ALPHANUMERIC',
  LAST_NAME_MUST_CONTAIN_ONLY_ALPHANUMERIC = 'LAST_NAME_MUST_CONTAIN_ONLY_ALPHANUMERIC',
  NAME_MUST_CONTAIN_ONLY_ALPHANUMERIC_AND_SPECIAL = 'NAME_MUST_CONTAIN_ONLY_ALPHANUMERIC_AND_SPECIAL',
  LABEL_NAME_MUST_CONTAIN_ONLY_ALPHANUMERIC_AND_SPECIAL = 'LABEL_NAME_MUST_CONTAIN_ONLY_ALPHANUMERIC_AND_SPECIAL',
  LABEL_NAME_ALREADY_EXISTS = 'LABEL_NAME_ALREADY_EXISTS',
  COMPANY_NOT_FOUND = 'COMPANY_NOT_FOUND',
  USER_ACCOUNT_OWNER_ROLE_TRANSFER_ERROR = 'USER_ACCOUNT_OWNER_ROLE_TRANSFER_ERROR',
  USER_ROLE_NOT_VALID = 'USER_ROLE_NOT_VALID',
  USER_EDIT_VEHICLE_ALREADY_EXISTS = 'USER_EDIT_VEHICLE_ALREADY_EXISTS',
  USER_EDIT_EMPLOYEE_ALREADY_EXISTS = 'USER_EDIT_EMPLOYEE_ALREADY_EXISTS',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  CSV_IMPORT_INVALID_HEADER = 'CSV_IMPORT_INVALID_HEADER',
  CSV_IMPORT_EMPTY_HEADER = 'CSV_IMPORT_EMPTY_HEADER',
  OPENSEARCH_GENERAL_ERROR = 'OPENSEARCH_GENERAL_ERROR',
  OPENSEARCH_SCROLL_OVERDATED_ERROR = 'OPENSEARCH_SCROLL_OVERDATED_ERROR',
  PAYMENT_API_CREATE_CC_ERROR = 'PAYMENT_API_CREATE_CC_ERROR',
  PAYMENT_API_PAYMENT_ERROR = 'PAYMENT_API_PAYMENT_ERROR',
  FINANCIAL_ACCOUNT_NOT_FOUND = 'FINANCIAL_ACCOUNT_NOT_FOUND',
  PARKING_GET_TOKEN_ERROR = 'PARKING_GET_TOKEN_ERROR',
  PARKING_STOP_PARKING_ERROR = 'PARKING_STOP_PARKING_ERROR',
  SUBSCRIPTIONS_NOT_FOUND = 'SUBSCRIPTIONS_NOT_FOUND',
  INVALID_SUBSCRIPTION_SELECTION = 'INVALID_SUBSCRIPTION_SELECTION',
  GENERAL_ERROR = 'GENERAL_ERROR',
  INTEGRATION_FACADE_UNAVAILABLE = 'INTEGRATION_FACADE_UNAVAILABLE',
  STRAPI_UNAVAILABLE = 'STRAPI_UNAVAILABLE',
  REDMINE_API_CREATE_ERROR = 'REDMINE_API_CREATE_ERROR',
  BAD_REQUEST = 'BAD_REQUEST',
  ACCESS_DENIED = 'ACCESS_DENIED',
  POLICY_MANAGEMENT_SERVICE_UNAVAILABLE = 'POLICY_MANAGEMENT_SERVICE_UNAVAILABLE',
  POLICY_MANAGEMENT_SERVICE_POLICY_NOT_FOUND = 'POLICY_MANAGEMENT_SERVICE_POLICY_NOT_FOUND',
  SUBSCRIPTIONS_CAN_NOT_SET_BACKUP_SUBSCRIPTION = 'SUBSCRIPTIONS_CAN_NOT_SET_BACKUP_SUBSCRIPTION',
  EMPLOYEE_PROFILE_NAME_CAN_NOT_BE_DUPLICATED = 'EMPLOYEE_PROFILE_NAME_CAN_NOT_BE_DUPLICATED',
  TOP_UP_METHOD_NOT_FOUND = 'TOP_UP_METHOD_NOT_FOUND',
  EMPLOYEE_NOT_FOUND = 'EMPLOYEE_NOT_FOUND',
  CITY_NOT_FOUND = 'CITY_NOT_FOUND',
  ZONE_NOT_FOUND = 'ZONE_NOT_FOUND',
  KAFKA_MESSAGE_ERROR = 'KAFKA_MESSAGE_ERROR',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  PERMISSION_CONFIGURATION_ERROR = 'PERMISSION_CONFIGURATION_ERROR',
  INVALID_PERMISSION = 'INVALID_PERMISSION',
  BILLING_UNIT_NOT_SUPPORTED = 'BILLING_UNIT_NOT_SUPPORTED',
  FILE_STORAGE_INTEGRATION_ERROR = 'FILE_STORAGE_INTEGRATION_ERROR',
  FILE_STORAGE_NOT_FOUND = 'FILE_STORAGE_NOT_FOUND',
  ACCOUNT_REPORT_ALREADY_EXISTS = 'ACCOUNT_REPORT_ALREADY_EXISTS',
}

export enum TopBarMessageResponseTypeEnum {
  SINGLE_OUT_OF_BALANCE = 'SINGLE_OUT_OF_BALANCE',
  SINGLE_BALANCE_LOW = 'SINGLE_BALANCE_LOW',
  SOME_OUT_OF_BALANCE = 'SOME_OUT_OF_BALANCE',
  SOME_BALANCE_LOW = 'SOME_BALANCE_LOW',
  ALL_OUT_OF_BALANCE = 'ALL_OUT_OF_BALANCE',
  SINGLE_ACCOUNT_NEVER_TOP_UP = 'SINGLE_ACCOUNT_NEVER_TOP_UP',
  MULTIPLE_ACCOUNT_NEVER_TOP_UP = 'MULTIPLE_ACCOUNT_NEVER_TOP_UP',
}

export enum OpensearchSearchRequestOpenSearchDataTypeEnum {
  ACTIVE_PARKINGS = 'ACTIVE_PARKINGS',
  ACCOUNT_TOP_UPS_SHORT = 'ACCOUNT_TOP_UPS_SHORT',
  ACCOUNT_TOP_UPS = 'ACCOUNT_TOP_UPS',
  TRANSACTIONS_MONTHLY_PRICE = 'TRANSACTIONS_MONTHLY_PRICE',
  TRANSACTION_HISTORY = 'TRANSACTION_HISTORY',
  TRANSACTION_HISTORY_SHORT = 'TRANSACTION_HISTORY_SHORT',
  INVOICES = 'INVOICES',
}

export enum ColumnConfigurationColumnEnum {
  ACTIVE_PARKING_ID = 'ACTIVE_PARKING_ID',
  ACTIVE_PARKING_PLATE_NUMBER = 'ACTIVE_PARKING_PLATE_NUMBER',
  ACTIVE_PARKING_NAME = 'ACTIVE_PARKING_NAME',
  ACTIVE_PARKING_SURNAME = 'ACTIVE_PARKING_SURNAME',
  ACTIVE_PARKING_PHONE_NUMBER = 'ACTIVE_PARKING_PHONE_NUMBER',
  ACTIVE_PARKING_START_TIME = 'ACTIVE_PARKING_START_TIME',
  ACTIVE_PARKING_END_TIME = 'ACTIVE_PARKING_END_TIME',
  ACTIVE_PARKING_CITY = 'ACTIVE_PARKING_CITY',
  ACTIVE_PARKING_ZONE = 'ACTIVE_PARKING_ZONE',
  TRANSACTION_HISTORY_TRANSACTION_DATE = 'TRANSACTION_HISTORY_TRANSACTION_DATE',
  TRANSACTION_HISTORY_NAME = 'TRANSACTION_HISTORY_NAME',
  TRANSACTION_HISTORY_SURNAME = 'TRANSACTION_HISTORY_SURNAME',
  TRANSACTION_HISTORY_PHONE_NUMBER = 'TRANSACTION_HISTORY_PHONE_NUMBER',
  TRANSACTION_HISTORY_USER_PROFILES = 'TRANSACTION_HISTORY_USER_PROFILES',
  TRANSACTION_HISTORY_DEPARTMENT = 'TRANSACTION_HISTORY_DEPARTMENT',
  TRANSACTION_HISTORY_PLATE_NUMBER = 'TRANSACTION_HISTORY_PLATE_NUMBER',
  TRANSACTION_HISTORY_SERVICE_NAME = 'TRANSACTION_HISTORY_SERVICE_NAME',
  TRANSACTION_HISTORY_TRANSACTION_TYPE = 'TRANSACTION_HISTORY_TRANSACTION_TYPE',
  TRANSACTION_HISTORY_TRANSACTION_DESCRIPTION = 'TRANSACTION_HISTORY_TRANSACTION_DESCRIPTION',
  TRANSACTION_HISTORY_COST_CENTER = 'TRANSACTION_HISTORY_COST_CENTER',
  TRANSACTION_HISTORY_AMOUNT = 'TRANSACTION_HISTORY_AMOUNT',
  ACCOUNT_TOP_UP_ID = 'ACCOUNT_TOP_UP_ID',
  ACCOUNT_TOP_UP_CARD_BRAND = 'ACCOUNT_TOP_UP_CARD_BRAND',
  ACCOUNT_TOP_UP_CARD_NUMBER = 'ACCOUNT_TOP_UP_CARD_NUMBER',
  ACCOUNT_TOP_UP_CARD_BRAND_CARD_NUMBER = 'ACCOUNT_TOP_UP_CARD_BRAND_CARD_NUMBER',
  ACCOUNT_TOP_UP_TOTAL_AMOUNT = 'ACCOUNT_TOP_UP_TOTAL_AMOUNT',
  ACCOUNT_TOP_UP_TIMESTAMP = 'ACCOUNT_TOP_UP_TIMESTAMP',
  ACCOUNT_TOP_UP_PAYMENT_TYPE = 'ACCOUNT_TOP_UP_PAYMENT_TYPE',
  INVOICING_INVOICE_ID = 'INVOICING_INVOICE_ID',
  INVOICING_INVOICE_NAME = 'INVOICING_INVOICE_NAME',
  INVOICING_INVOICE_SALE_DATE = 'INVOICING_INVOICE_SALE_DATE',
  INVOICING_INVOICE_BILLING_PERIOD = 'INVOICING_INVOICE_BILLING_PERIOD',
  INVOICING_INVOICE_CATEGORY = 'INVOICING_INVOICE_CATEGORY',
  INVOICING_INVOICE_COST_CENTER = 'INVOICING_INVOICE_COST_CENTER',
  INVOICING_INVOICE_ATTACHMENT_FILE = 'INVOICING_INVOICE_ATTACHMENT_FILE',
  INVOICING_INVOICE_ATTACHMENTS_BUCKET = 'INVOICING_INVOICE_ATTACHMENTS_BUCKET',
  INVOICING_INVOICE_ATTACHMENT = 'INVOICING_INVOICE_ATTACHMENT',
  INVOICING_INVOICE_RECIPIENTS = 'INVOICING_INVOICE_RECIPIENTS',
  INVOICING_INVOICE_FILE = 'INVOICING_INVOICE_FILE',
  INVOICING_INVOICE_BUCKET = 'INVOICING_INVOICE_BUCKET',
  INVOICING_INVOICE = 'INVOICING_INVOICE',
  INVOICING_INVOICE_DATE_FROM = 'INVOICING_INVOICE_DATE_FROM',
  INVOICING_INVOICE_DATE_TO = 'INVOICING_INVOICE_DATE_TO',
  INVOICING_INVOICE_YEAR = 'INVOICING_INVOICE_YEAR',
  INVOICING_INVOICE_MONTH = 'INVOICING_INVOICE_MONTH',
}

export enum ColumnConfigurationColumnTypeEnum {
  PHONE_NUMBER = 'PHONE_NUMBER',
  STRING = 'STRING',
  STRING_CONCAT = 'STRING_CONCAT',
  TOP_UP_AMOUNT = 'TOP_UP_AMOUNT',
  ISO_DATE_WITH_TIME = 'ISO_DATE_WITH_TIME',
  LOCAL_DATE = 'LOCAL_DATE',
  CURRENCY = 'CURRENCY',
  LABELS = 'LABELS',
  INVOICE_BADGE = 'INVOICE_BADGE',
  DOWNLOAD_LINK = 'DOWNLOAD_LINK',
}

export enum NotificationDtoReadStatusEnum {
  READ = 'READ',
  UNREAD = 'UNREAD',
}

export enum GenerateReportResponseStatusEnum {
  GENERATING = 'GENERATING',
  GENERATED = 'GENERATED',
  FAILED = 'FAILED',
  NOT_GENERATED = 'NOT_GENERATED',
}

export enum GetConfigurationParamsDataTypeEnum {
  ACTIVE_PARKINGS = 'ACTIVE_PARKINGS',
  ACCOUNT_TOP_UPS_SHORT = 'ACCOUNT_TOP_UPS_SHORT',
  ACCOUNT_TOP_UPS = 'ACCOUNT_TOP_UPS',
  TRANSACTIONS_MONTHLY_PRICE = 'TRANSACTIONS_MONTHLY_PRICE',
  TRANSACTION_HISTORY = 'TRANSACTION_HISTORY',
  TRANSACTION_HISTORY_SHORT = 'TRANSACTION_HISTORY_SHORT',
  INVOICES = 'INVOICES',
}

export enum GetConfigurationParamsEnum {
  ACTIVE_PARKINGS = 'ACTIVE_PARKINGS',
  ACCOUNT_TOP_UPS_SHORT = 'ACCOUNT_TOP_UPS_SHORT',
  ACCOUNT_TOP_UPS = 'ACCOUNT_TOP_UPS',
  TRANSACTIONS_MONTHLY_PRICE = 'TRANSACTIONS_MONTHLY_PRICE',
  TRANSACTION_HISTORY = 'TRANSACTION_HISTORY',
  TRANSACTION_HISTORY_SHORT = 'TRANSACTION_HISTORY_SHORT',
  INVOICES = 'INVOICES',
}

export enum GenerateReportParamsReportTypeEnum {
  AllExpensesSummary = 'all-expenses-summary',
  AllCostCentersSummary = 'all-cost-centers-summary',
}

export enum GenerateReportParamsEnum {
  AllExpensesSummary = 'all-expenses-summary',
  AllCostCentersSummary = 'all-cost-centers-summary',
}

export enum CheckReportGenerationStatusParamsReportTypeEnum {
  AllExpensesSummary = 'all-expenses-summary',
  AllCostCentersSummary = 'all-cost-centers-summary',
}

export enum CheckReportGenerationStatusParamsEnum {
  AllExpensesSummary = 'all-expenses-summary',
  AllCostCentersSummary = 'all-cost-centers-summary',
}
export interface InvoiceRecipientDto {
  id: string;
  email: string;
}
